/**
 * The newest path in a history stack (newest last) that `pattern` accepts,
 * or null when none does.
 */
export const findPreviousPath = (
  paths: readonly string[],
  pattern: (path: string) => boolean
): string | null => {
  for (let i = paths.length - 1; i >= 0; i--) {
    if (pattern(paths[i])) return paths[i];
  }
  return null;
};
